import { render, staticRenderFns } from "./ExtratoCda.vue?vue&type=template&id=927f5010&scoped=true&"
import script from "./ExtratoCda.vue?vue&type=script&lang=js&"
export * from "./ExtratoCda.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoCda.vue?vue&type=style&index=0&id=927f5010&scoped=true&lang=css&"
import style1 from "./ExtratoCda.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927f5010",
  null
  
)

export default component.exports